const CptName = 'ComUnorderLine'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      children: []
    },
    cpt: CptName
  }
}

export default {
  name: 'unorder_list',
  formatData
}